// Shared identity helpers — single source of truth for deriving a display name and
// avatar initials from a user's email. Previously duplicated in TopBar's AccountMenu
// and PortfolioLayout's header; consumed now by the shared UserMenu component.
//
// Both derive from the local part of the email (before "@"), split on ".":
//   "operator@crownrms.test"      → initials "O",  name "Operator"
//   "jane.doe@crownrms.test"      → initials "JD", name "Jane Doe"

const localPart = (email: string): string[] =>
  (email ?? '')
    .split('@')[0]
    .split('.')
    .filter(Boolean)

// Up-to-two-letter uppercase initials from the email local part.
export function initialsFromEmail(email: string): string {
  return localPart(email)
    .map((segment) => segment[0]?.toUpperCase() ?? '')
    .join('')
    .slice(0, 2)
}

// Title-cased display name from the email local part ("jane.doe" → "Jane Doe").
export function displayNameFromEmail(email: string): string {
  return localPart(email)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(' ')
}
